// src/icons/PiggyBank.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function PiggyBank({
  strokeWidth = "1.5",
  strokeLinecap = "butt",
  strokeLinejoin = "miter"
}) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 21 19",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M4.2852 2.80323L4.28378 2.81174C4.16768 3.50397 4.04904 4.21137 3.96368 4.82785C3.3302 5.5199 2.84097 6.34727 2.54459 7.26219H1.75H1.09375V7.91844V10.8244V11.4626L1.7317 11.4804L2.59376 11.5045C2.97833 12.6034 3.64313 13.5696 4.50179 14.318L3.94048 15.3554L3.63587 15.9184L4.19114 16.237L5.64215 17.0693L6.19546 17.3867L6.52843 16.8426L7.20243 15.7413C7.73371 15.8781 8.29024 15.9508 8.86295 15.9508H10.733C11.2494 15.9508 11.7526 15.8917 12.2361 15.7798L12.7333 16.6734L13.0537 17.2493L13.6282 16.9265L15.0524 16.1264L15.6282 15.8028L15.301 15.2291L14.8823 14.495C16.1356 13.4907 17.0179 12.0401 17.2872 10.3828H18.3359C19.2032 10.3828 19.9063 9.67973 19.9063 8.81242C19.9063 7.9451 19.2032 7.242 18.3359 7.242H17.0447C16.1753 4.58759 13.6788 2.66994 10.733 2.66994H8.86295C8.17571 2.66994 7.51184 2.77455 6.88698 2.96907C6.72823 2.86308 6.56121 2.75214 6.39011 2.63848L6.38912 2.63782C6.057 2.4172 5.70863 2.18579 5.36863 1.95616L4.52263 1.3848L4.3541 2.39166L4.28524 2.80302L4.2852 2.80323Z",
            stroke: "currentColor",
            strokeWidth,
            strokeLinecap,
            strokeLinejoin
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M8.87903 5.07309H11.1462",
            stroke: "currentColor",
            strokeWidth,
            strokeLinecap
          }
        ),
        /* @__PURE__ */ jsx(
          "ellipse",
          {
            cx: "5.45801",
            cy: "7.36851",
            rx: "0.755735",
            ry: "0.807216",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}

export {
  PiggyBank
};
